<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Categorias de Material</h3>
                    </div>

                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="materialCategory">Categorias de Material</label>
                                    <select name="materialCategory[]" id="materialCategory" v-model="ordered" size="8"
                                            multiple>
                                        <option :value="index" v-for="(materialCategory, index) in materialCategories">
                                            {{ materialCategory.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setMaterialCategories">Ordenar Categorias de
                                    Material <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(materialCategory,index) in selected' :key="materialCategory.id"
                                        class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left"></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="stages" :id="'stage' + materialCategory.id">{{ index + 1 }}. {{ materialCategory.name }} </span>
                                        <button class="btn btn-danger pull-right"
                                                @click="remove(materialCategory, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar
                                </button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação
                                    <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default {
        data: function () {
            return {
                materialCategories: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getMaterialCategoriesArray: function (data) {
                let array = [];
                $.each(data, function (index, value) {
                    if (value.sort_by) {
                        array.push(index);
                    }
                });
                return array;
            },
            getMaterialCategories: function () {
                let self = this;
                let api = self.$store.state.api + 'materialCategory?paginated=false';
                let materialCategory = $('#materialCategory');

                self.$http.get(api)
                    .then((response) => {
                        self.materialCategories = response.data.data;
                        self.ordered = self.getMaterialCategoriesArray(self.materialCategories);
                    })
                    .then(() => {
                        materialCategory.bootstrapDualListbox();
                        materialCategory.ready(function () {
                            materialCategory.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Promotional Materials', 'error');
                    });
            },
            setMaterialCategories: function () {
                const self = this;
                let materialCategory = self.selected;

                $('#materialCategory').find(':selected').each(function () {
                    materialCategory.push(self.materialCategories[$(this).val()]);
                });

                self.selected = materialCategory;
                self.order = true;
            },
            save: function () {
                const self = this;

                postReorder(self, self.selected, "sort/materialCategory", self.getMaterialCategoriesArray);
            },
            remove: function (materialCategory, index) {
                const self = this;
                const api = self.$store.state.api + 'materialCategory/' + materialCategory.id;

                let array = [];
                $.each(self.selected, function (key, value) {
                    if (index !== key) {
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function () {
                window.location.reload();
            }
        },
        mounted: function () {
            this.getMaterialCategories();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MaterialCategoryOrder/Index.vue